"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = exports.StyledButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRainbowComponents = require("react-rainbow-components");

var StyledButton = (0, _styledComponents["default"])(_reactRainbowComponents.Button).withConfig({
  displayName: "styled__StyledButton",
  componentId: "sc-1b6csoa-0"
})(["width:100%;margin-top:16px;"]);
exports.StyledButton = StyledButton;
var StyledInput = (0, _styledComponents["default"])(_reactRainbowComponents.Input).withConfig({
  displayName: "styled__StyledInput",
  componentId: "sc-1b6csoa-1"
})(["margin-bottom:12px;"]);
exports.StyledInput = StyledInput;